<template>
  <div class="wrapper">
    <CustomTable
      title=""
      :rowsData="this.invoiceListData"
      :columns="this.frameTypeParamTable"
      :custom-body="true"
      :small="true"
      :hide-footer-title="true"
      :sticky-header="false"
      :loading="loading"
      :add-btn="true"
      :on-add-click="this.handleAddClick"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center">
            {{ props.row.frame_param_link_id }}
          </custom-table-cell>
          <custom-table-cell align="left">
            {{ props.row.frame_param_type_name }}
          </custom-table-cell>
          <custom-table-cell align="left">
            {{ props.row.frame_param_type_code }}
          </custom-table-cell>
          <custom-table-cell align="center">
            <CustomIcon
              icon="trash"
              :approve-mode="true"
              :loading="this.delBtnLoading[props.row?.frame_param_link_id]"
              :approve="
                () =>
                  this.onDeleteFrameTypeParam(props.row?.frame_param_link_id)
              "
            />
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
    <CustomModalFooter
      :onCancel="this.closeModal"
      :hide-submit-btn="true"
      cancel-btn-text="Закрыть"
    />
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import Clickable from "@/components/common/Clickable";
import CustomIcon from "@/components/common/CustomIcon";
import {
  getFrameTypeParamsList,
  onDeleteFrameTypeParam,
  updateFrameLinkParam,
} from "@/views/Frames/Types/services";
import { frameTypeParamTable } from "./services";
import { appActions } from "@/services/store/modules/app_module/app_actions";
import { MODAL_NAMES } from "@/constants";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";

export default {
  name: "frame-type-params",
  components: {
    CustomTableCell,
    CustomTable,
    CustomModalFooter,
    Clickable,
    CustomIcon,
  },
  props: ["data", "closeModal"],
  data() {
    return {
      frameTypeParamTable,
      invoiceListData: [],
      btnLoading: {},
      delBtnLoading: {},
      loading: false,
    };
  },
  methods: {
    async fetchParams() {
      this.loading = true;
      const res = await getFrameTypeParamsList(this.data.frame_type_id);
      this.loading = false;
      if (!res) return;
      this.invoiceListData = res;
    },
    async onDeleteFrameTypeParam(frame_param_link_id) {
      this.delBtnLoading = {
        ...this.delBtnLoading,
        [frame_param_link_id]: true,
      };
      const res = await onDeleteFrameTypeParam(frame_param_link_id);
      this.delBtnLoading = {
        ...this.delBtnLoading,
        [frame_param_link_id]: false,
      };
      if (!res) return;
      this.showSucceedSnackbar();
      this.fetchParams();
    },
    async handleAddClick() {
      this.$store.commit(
        appActions.showModal(MODAL_NAMES.UPD_FRAME_TYPE_PARAM, {
          onSubmit: (body) => this.onAddSubmit(body),
          title: "Добавить параметр",
          frame_type_id: this.data.frame_type_id,
        })
      );
    },
    async onAddSubmit(body) {
      const res = await updateFrameLinkParam(body);
      if (!res) return;
      this.showSucceedSnackbar();
      this.$store.commit(appActions.showModal(MODAL_NAMES.FRAME_TYPE_PARAMS, {
          title: 'Параметры',
          frame_type_id: this.data.frame_type_id,
        }));
    },
  },
  mounted() {
    this.fetchParams();
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar };
  },
};
</script>

<style scoped lang="scss">
// Настроить размер модалки
.wrapper {
  width: 640px;
}

@media (max-width: 576px) {
  .wrapper {
    max-width: 100%;
  }
}
</style>
